import { useEffect } from "react"

import { history } from "shared/lib/browserHistory"

import { saveLastHistoryAction } from "features/scroll-management/model/scroll-position-store"

export function useHistoryActionListener() {
  useEffect(() => {
    history()?.listen(args => saveLastHistoryAction(args.action))
  }, [])
}
